import React from 'react'
import PropTypes from 'prop-types'

import * as CONST from './../../Reducers/Ambassador/const'
import StyledStatusLabel from './style'

const getStatusProp = statusText => {
  switch (statusText.toLowerCase()) {
    case 'available':
      return { active: true }
    case 'published':
    case 'paid':
    case 'completed':
    case CONST.AMBASSADOR_STATUS_KEY.ACTIVE:
      return { success: true }

    case 'booked':
    case CONST.AMBASSADOR_STATUS_KEY.WAITING_FOR_REVIEW:
      return { waitingForReview: true }
    case 'checked-in':
    case 'checked_in':
      return { checkedIn: true }
    case 'reviewed':
    case 'canceled':
      return { warning: true }
    case 'under review':
      return { underReview: true }
    case 'under_review':
      return { underReview: true }

    case 'draft':
      return { draft: true }
    case CONST.AMBASSADOR_STATUS_KEY.PENDING:
      return { pending: true }
    case CONST.AMBASSADOR_STATUS_KEY.PRE_ACCESS:
      return { preAccess: true }

    default:
      return { default: true }
  }
}

const StatusLabel = ({ status, isSpied = false }) => (
  <StyledStatusLabel isSpied={isSpied} {...getStatusProp(status)}>
    {getReadableStatus(status)}
  </StyledStatusLabel>
)

StatusLabel.propType = {
  status: PropTypes.string.isRequired,
}

export { StatusLabel }

const getReadableStatus = status => {
  if (Object.values(CONST.AMBASSADOR_STATUS_KEY).includes(status))
    return CONST.AMBASSADOR_STATUS_LABEL[status]

  switch (status) {
    case 'ACTIVE':
      return 'active'
    case 'DRAFT':
      return 'draft'
    case 'AVAILABLE':
      return 'available'
    case 'BOOKED':
      return 'booked'
    case 'TERMINATING':
      return 'terminating'
    case 'PRE_ACCESS':
      return 'pre_access'
    case 'CANCELLED':
      return 'cancelled'
    case 'CHECKED_IN':
      return 'checked-in'
    case 'UNDER_REVIEW':
      return 'under-review'
    case 'COMPLETED':
      return 'completed'
    case 'PAID':
      return 'paid'
    default:
      return status
  }
}



// WEBPACK FOOTER //
// ./src/Components/StatusLabel/index.js